import { DetailBylineRow } from '~/ui-rocco/pages/detail-shared';
import { useRevampPublishDate } from './RevampPublishDate';

interface RevampBylineRowProps {
    /** Who the article is by. */
    professional?: { title: string; link: string };
    /** When it was published, as the CMS stores it. */
    publishDate?: string;
    /** Where Back goes when this page opened the tab and there is nothing behind it. */
    fallbackLink: string;
    /** `dark` = white on the masthead's photograph. */
    theme?: 'light' | 'dark';
}

/**
 * The product page's byline row, under the article's headline: Back at the
 * gutter, "featuring" and the professional in a 51rem track from it, and the
 * publish date ranged right to the far gutter where the product shows the
 * place.
 */
export const RevampBylineRow = ({
    professional,
    publishDate,
    fallbackLink,
    theme = 'light',
}: RevampBylineRowProps) => {
    const published = useRevampPublishDate(publishDate);

    return (
        <DetailBylineRow
            // Capped at the 1920 frame and centred, as the body's grid is:
            // uncapped, Back and the date rode the viewport's far edges on
            // wide screens while the headline held the frame. mt-3 below md:
            // with Back hidden there the row is two short lines, and the
            // shared 24px left them adrift of the headline they credit.
            className="mx-auto w-full max-w-(--ap-page-width) max-md:mt-3 max-md:px-4.5 md:px-[3rem]"
            theme={theme}
            backFallbackLink={fallbackLink}
            byLabel="featuring"
            professional={professional}
            trailing={
                published ? (
                    <time dateTime={published.iso}>{published.label}</time>
                ) : undefined
            }
        />
    );
};
